"use strict";

require("core-js/modules/es6.function.name");

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _control = require("@waglabs/control");

var _ = require("..");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SelectFormField =
/*#__PURE__*/
function (_react$Component) {
  _inheritsLoose(SelectFormField, _react$Component);

  function SelectFormField() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _react$Component.call.apply(_react$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (form, field) {
      return function (value) {
        if (field && field.onChange) {
          form.setFieldValue(field.name, value.value);
        }
      };
    });

    return _this;
  }

  var _proto = SelectFormField.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        containerProps = _this$props.containerProps,
        hasErrorMessage = _this$props.hasErrorMessage,
        label = _this$props.label,
        options = _this$props.options,
        name = _this$props.name;
    return _react.default.createElement(_.FormField, {
      name: name,
      render: function render(_ref) {
        var _ref$field = _ref.field,
            fieldName = _ref$field.name,
            onBlur = _ref$field.onBlur,
            onFocus = _ref$field.onFocus,
            value = _ref$field.value,
            field = _ref.field,
            _ref$form = _ref.form,
            touched = _ref$form.touched,
            errors = _ref$form.errors,
            form = _ref.form;
        var isTouched = touched[fieldName];
        var isValid = !errors[fieldName];
        var errorMessage = errors[fieldName];
        return _react.default.createElement(_.FormFieldContainer, containerProps, _react.default.createElement(_control.SelectField, {
          label: label,
          name: fieldName,
          onBlur: onBlur,
          onChange: _this2.handleChange(form, field),
          onFocus: onFocus,
          options: options,
          value: value
        }), hasErrorMessage && isTouched && !isValid && _react.default.createElement(_.FormFieldErrorMessage, null, errorMessage));
      }
    });
  };

  return SelectFormField;
}(_react.Component);

_defineProperty(SelectFormField, "defaultProps", {
  hasErrorMessage: true
});

var _default = SelectFormField;
exports.default = _default;